export const exchangeSummaryTemplate = `<div>
  <div>
    {{#if (eq exchangeSummary.fixedSide 'buy')}}
    <div><label>Selling</label></div>
    {{else}}
    <div><label>Selling (includes fees)</label></div>
    {{/if}}
    {{#if (eq exchangeSummary.fixedSide 'buy')}}
    <div class="d-flex is-space-between">
      <div>
        <h2>
          {{ currencyPipe exchangeSummary.feeAmountPlusSellAmount currencyCode=exchangeSummary.sellCurrency display="symbol-narrow" }}
        </h2>
      </div>
      <div>
        {{{ currencyToFlag exchangeSummary.sellCurrency '40px' }}}
      </div>
    </div>
    <div>
      <span
        >({{ currencyPipe exchangeSummary.sellAmount currencyCode=exchangeSummary.sellCurrency display="symbol-narrow" }}
        +
        {{ currencyPipe exchangeSummary.feeAmount currencyCode=exchangeSummary.sellCurrency display="symbol-narrow" }})</span
      >
    </div>
    {{else}}
    <div class="d-flex is-space-between">
      <div>
        <h2>
          {{ currencyPipe exchangeSummary.sellAmount currencyCode=exchangeSummary.sellCurrency display="symbol-narrow" }}
        </h2>
      </div>
      <div>
        {{{ currencyToFlag exchangeSummary.sellCurrency '40px' }}}
      </div>
    </div>
    {{/if}}
  </div>
  <hr />
  <div class="mt-3">
    <div>
      {{#if (eq exchangeSummary.fixedSide 'buy')}}
      <div><label>Buying</label></div>
      {{else}}
      <div><label>Buying (includes fees)</label></div>
      {{/if}}
      {{#if (eq exchangeSummary.fixedSide 'sell')}}
      <div class="d-flex is-space-between">
        <div>
          <h2>
            {{ currencyPipe exchangeSummary.buyAmountMinusFeeAmount currencyCode=exchangeSummary.buyCurrency display="symbol-narrow" }}
          </h2>
        </div>
        <div>
          {{{ currencyToFlag exchangeSummary.buyCurrency '40px' }}}
        </div>
      </div>
      <div>
        <span
          >({{ currencyPipe exchangeSummary.buyAmount currencyCode=exchangeSummary.buyCurrency display="symbol-narrow" }}
          -
          {{ currencyPipe exchangeSummary.feeAmount currencyCode=exchangeSummary.buyCurrency display="symbol-narrow" }})</span
        >
      </div>
      {{else}}
      <div class="d-flex is-space-between">
        <div>
          <h2>
            {{ currencyPipe exchangeSummary.buyAmount currencyCode=exchangeSummary.buyCurrency display="symbol-narrow" }}
          </h2>
        </div>
        <div>
          {{{ currencyToFlag exchangeSummary.buyCurrency '40px' }}}
        </div>
      </div>
      {{/if}}
    </div>
  </div>`;
